// Generated by script, don't edit it please.
import createSvgIcon from '../../createSvgIcon';
import AngleUpSvg from '@rsuite/icon-font/lib/legacy/AngleUp';
var AngleUp = createSvgIcon({
    as: AngleUpSvg,
    ariaLabel: 'angle up',
    category: 'legacy',
    displayName: 'AngleUp'
});
export default AngleUp;
